// extracted by mini-css-extract-plugin
export default {"root":"MediaPlaceholder__root--kIlorx"};